import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@components/ui/Tooltip';

import { type FastTooltipShowProps } from './types';

const FastTooltipShow = ({
  title,
  children,
  side = 'top',
}: FastTooltipShowProps) => {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side}>{title}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export { FastTooltipShow };
